// For when an Okta user checks the existance of another Okta user
export const checkOktaUser = ({ token, email }) => ({
  HTTPMethod: "get",
  path: "/api/v1/sso/users/verify",
  queryParams: {
    email: email,
  },
  headers: {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});
